import React from "react";
import {connect} from "react-redux";

import { RiDeleteBin6Line } from "react-icons/ri";
import {useDrop} from "react-dnd";
const Bin = ({}) => {

    const [{canDrop, isOver}, drop] = useDrop(() => ({
        accept: ['planitem','lc'],
        drop: () => ({
            id: "wastebin",
            typename: `wastebin`,
        }),
        collect: (monitor) => ({
            isOver: monitor.isOver(),
            canDrop: monitor.canDrop()
        })
    }))

    return(
        <div className='bubble bin'
             ref={drop}>
            <RiDeleteBin6Line fontSize='small'/>
        </div>
    )
}



function mapStateToProps(state, ownProps) {
    return state
}

const mapDispatchToProps = dispatch => {
    // the state will be modified on answer ...
    return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(Bin)